/**
 * Create by xiehan on 2018/11/08
 * Tab
 */
// @使用方法:
// import tab from '@/views/layout/components/setTab'
// 全路径跳转：
// this.$router.push({ path: '/home/appDelivery/releaseOverview?id=5be2826a10d48b32962629fb' })
// tab.selectTab('appDelivery')
// name跳转：
// this.$router.push({ name: 'addAppDelivery' })
// tab.selectTab('appDelivery')
// 注意：selectTab参数必须是二级菜单(跳转的页面如不是二级菜单、参数则是其父页面的name)

import store from '@/store'

class tab {
  static selectTab (code) {
    store.commit('setActiveTab', code)
    let index = store.getters.findTabIndexByCode(code)
    if (index >= 0) return
    let tabInfo = store.getters.findMenuByCode(code)
    store.commit('addTab', tabInfo)
  }
}
export default tab
